// Shared poll cadence for redeem jobs (redeemCsv.js + EmailRedeemPopup.vue).
// Derived from systemConfig so we never wait out the whole estimate before the
// first check: floor = default_poll_interval_refresh_millisecond × 4,
// ceiling = default_redeem_progress_bar_complete_second × 1000,
// initial = clamp(estimated_time / TARGET_POLL_COUNT, floor, ceiling),
// backoff = 1.5x per tick, capped at ceiling.
export const POLL_BACKOFF_FACTOR = 1.5;

// Fallbacks for when systemConfig hasn't loaded yet.
export const FALLBACK_FLOOR_MS = 3000;
export const FALLBACK_CEIL_MS = 60000;

const TARGET_POLL_COUNT = 15;

export function deriveBounds(systemConfig) {
  const floorMs =
    Number(systemConfig && systemConfig.default_poll_interval_refresh_millisecond) * 4 ||
    FALLBACK_FLOOR_MS;
  const ceilMs =
    Number(systemConfig && systemConfig.default_redeem_progress_bar_complete_second) * 1000 ||
    FALLBACK_CEIL_MS;
  return { floorMs, ceilMs: Math.max(ceilMs, floorMs) };
}

// First poll delay (ms). Non-"second" units fall back to floor.
export function pickInitialPollDelay(estimated_time, estimated_time_type, systemConfig) {
  const { floorMs, ceilMs } = deriveBounds(systemConfig);
  const seconds =
    estimated_time_type === "second" ? Number(estimated_time) || 0 : 0;
  if (!seconds) return floorMs;
  const target_ms = Math.round((seconds * 1000) / TARGET_POLL_COUNT);
  return Math.min(Math.max(target_ms, floorMs), ceilMs);
}

// Next poll delay after a tick: back off 1.5x, capped at the ceiling.
export function nextPollDelay(currentDelay, systemConfig) {
  const { ceilMs } = deriveBounds(systemConfig);
  return Math.min(currentDelay * POLL_BACKOFF_FACTOR, ceilMs);
}
